import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import { getDriverRegistrationForms } from '../../shared/api/user';
import { useState, useEffect } from 'react';
import moment from 'moment';

import "./Drivers.css";
import { useNavigate } from "react-router-dom";

export default function BasicTable() {
    const navigate = useNavigate();
    const [registrations, setRegistrations] = useState([]);

    const init = async () => {
        let rows = await getDriverRegistrationForms();
        setRegistrations(rows.data.Forms);
        console.log(rows.data.Forms)
    }

    useEffect(() => {
        init();
    }, []);

    return (
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell>Name</TableCell>
                        <TableCell align="right">Phone</TableCell>
                        <TableCell align="right">Email</TableCell>
                        <TableCell align="right">License State</TableCell>
                        <TableCell align="right">Delivery Experience</TableCell>
                        <TableCell align="right">Car Model</TableCell>
                        <TableCell align="right">Car Year</TableCell>
                        <TableCell align="right">Delete</TableCell>
                        <TableCell align="right">Details</TableCell>
                        <TableCell align="right">Start Date</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {registrations?.map((row) => (
                        <TableRow
                            key={row._id}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <TableCell component="th" scope="row">
                                {row?.name}
                            </TableCell>
                            <TableCell align="right">{row?.phoneNumber}</TableCell>
                            <TableCell align="right">{row?.email}</TableCell>
                            <TableCell align="right">{row?.licenseState}</TableCell>
                            <TableCell align="right">{row?.deliveryExperience}</TableCell>
                            <TableCell align="right">{row?.carModel}</TableCell>
                            <TableCell align="right">{row?.carYear}</TableCell>
                            <TableCell align="right"><Button variant="text"><DeleteIcon></DeleteIcon></Button></TableCell>
                            <TableCell align="right"><Button onClick={() => navigateToDetails(row._id)} variant="text">View more</Button></TableCell>
                            <TableCell align="right">{moment(row?.contactDate).format('MMMM Do YYYY, h:mm:ss a')}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}